export const COLLECTION_NAME_LIMIT = 45;
export const COLLECTION_DESCRIPTION_LIMIT = 290;
export const KLYDO_NAME_LIMIT = 60;
export const KLYDO_SUBTITLE_LIMIT = 90;
export const USER_NAME_LIMIT = 20;
export const USER_DESCRIPTION_LIMIT = 400;
export const USER_TITLE_LIMIT = 60;
export const REVIEW_COMMENT_LIMIT = 500;
